// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"8503fb75","348":"e47ba50c","480":"9b8b027c"}[chunkId] + ".chunk.css";
};